<template>
  <v-container fluid :class="fillBackgroundClasses">
    <v-row justify="center">
      <v-col xs="12" md="6">
        <v-card outlined>
          <v-img class="white--text align-end" :width="imagewidth" :src="logo" />
          <v-progress-linear
            :indeterminate="this.isBusy"
            value="100"
            :color="this.appThemeComponentsMainColor"
          ></v-progress-linear>
          <v-card-subtitle class="pb-0"
            >Bienvenido a CONTPAQi® Firma Electrónica</v-card-subtitle
          >
          <v-card-text class="text--primary">
            <div>
              Por favor captura tus datos de usuario para ingresar a la
              aplicación:
            </div>
            <Signin></Signin>
          </v-card-text>

          <v-row justify="end">
            <p class="pt-4 mr-8">
              ¿No tienes cuenta?
              <a class="text-decoration-none blue--text lighten-2" :href="identidadesSingin">Regístrate</a>
            </p>
          </v-row>
          <v-row>
            <v-col cols="12">
              <notification-container
                class="mr-5 ml-5"
              ></notification-container>
            </v-col>
          </v-row>

          <v-card-actions class="white justify-center">
            <v-btn
              v-for="(social, i) in this.socials"
              :key="i"
              :color="social.color"
              class="white--text"
              fab
              icon
              small
              link
              :href="social.link"
              target="_blank"
            >
              <v-icon>{{ social.icon }}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-row>
          <v-col class="text-center">
            <v-btn
              v-for="(help, i) in this.helps"
              :key="i"
              text
              small
              link
              dark
              :href="help.link"
              target="_blank"
              >{{ help.text }}</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col xs="1" md="1">
        <version-tag></version-tag>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { panelData, footerData, appThemeData, userData } from '@/store/helpers'
import Signin from '@/modules/auth/components/Signin'
import logo from '@/assets/LogoCONTPAQiFirma_Positivo.png'

export default {
  name: 'SiginPage',
  components: {
    Signin
  },
  data() {
    return {
      logo
    }
  },
  computed: {
    ...appThemeData,
    ...panelData,
    ...footerData,
    ...userData,
    fillBackgroundClasses: {
      get() {
        return `fill-height ${this.appThemeBackgroundWelcome}`
      }
    },
    imagewidth(){
      return this.$vuetify.breakpoint.height <= 720 ? '140px' : '220px'
    }
  }
}
</script>
